import sessionManager from '../services/SessionManager';

const readCookie = (name) => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
};

const buildUrl = (path) => {
  if (!path) {
    throw new Error('apiFetch requires a valid path');
  }

  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Ensure proper URL construction - handle both cases:
  // Base URL with/without trailing slash + path with/without leading slash
  const baseUrl = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, ''); // Remove trailing slashes
  const cleanPath = path.startsWith('/') ? path : `/${path}`; // Ensure leading slash

  return `${baseUrl}${cleanPath}`;
};

export const apiFetch = (path, options = {}) => {
  const url = buildUrl(path);

  const fetchOptions = {
    credentials: options.credentials || 'include',
    ...options
  };

  const headers = new Headers(options.headers || {});
  let token = sessionManager.getAuthToken();
  if (!token) {
    token = readCookie('jwt') || readCookie('access_token');
  }

  if (token && !headers.has('Authorization')) {
    headers.set('Authorization', `Bearer ${token}`);
  }

  fetchOptions.headers = headers;

  return fetch(url, fetchOptions);
};

export const withAuthHeaders = (headers = {}) => {
  const mergedHeaders = new Headers(headers);
  const token = sessionManager.getAuthToken();

  if (token && !mergedHeaders.has('Authorization')) {
    mergedHeaders.set('Authorization', `Bearer ${token}`);
  }

  return mergedHeaders;
};

